import Vue from "vue";

export const System = {
  methods: {
    //TODO: 查询套餐
    async getSystemList() {
      let res = await this.$http.get("/tenant/ism/tree/list");
      return res;
    },
    //TODO: 获取会议记录
    async getMeetingList(obj) {
      let { pageSize, pageNum, type, meetingTitle } = obj;
      let res = await this.$http.get("/tenant/meeting/history/list", {
        pageSize,
        pageNum,
        type: type ?? null,
        meetingTitle: meetingTitle ?? "",
      });
      return res;
    },
    //TODO: 获取制度会议列表
    async getMeetingOption(obj) {
      let res = await this.$http.get("/tenant/ism/meeting/list");
      return res;
    },
    //TODO: 获取待我编辑会议记录
    async getEditMeetingList(obj) {
      let { pageSize, pageNum } = obj;
      let res = await this.$http.get("/tenant/meeting/history/wait/edit", {
        pageSize,
        pageNum,
      });
      return res;
    },
    //TODO: 获取待我主持会议记录
    async getHostMeetingList(obj) {
      let { pageSize, pageNum } = obj;
      let res = await this.$http.get("/tenant/meeting/history/wait/hold", {
        pageSize,
        pageNum,
      });
      return res;
    },
    //TODO: 获取待我参加会议记录
    async getJoinMeetingList(obj) {
      let { pageSize, pageNum } = obj;
      let res = await this.$http.get("/tenant/meeting/history/wait/join", {
        pageSize,
        pageNum,
      });
      return res;
    },
    //TODO：删除会议历史记录
    async deleteMeeting(id) {
      let res = await this.$http.delete(`/tenant/meeting/history/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res.data;
    },
    //TODO:获取制度内容（制度板块）
    async getSystemContent(id) {
      let res = await this.$http.get(`/tenant/ism/content/${id}`);
      return res.data;
    },
    //TODO:获取制度内容（会议管理板块）
    async getPersonContent(id) {
      let res = await this.$http.get(
        `/tenant/meeting/history/from/inBox/${id}`
      );
      return res.data;
    },
    //TODO:修改制度内容
    async updateSystemContent(data) {
      let res = await this.$http.put(`/tenant/ism/content`, data);

      return res;
    },
    //TODO:获取 检查表 和 检查人
    async getCheckTableInfo(data) {
      let res = await this.$http.get(`/tenant/check/type/list`, data);
      return res;
    },
    //TODO： 查找已发送的会议记录
    async SafeMeeting(id) {
      let res = await this.$http.get(`/tenant/meeting/history/${id}`);
      return res.data;
    },
    //TODO: 修改定时任务
    async SafeJob(data) {
      let res = await this.$http.put(`/tenant/job`, data);
      return res;
    },
    //TODO:发布会议(审核人发布)
    async sendMeetingMst(data) {
      let res = await this.$http.post(`/tenant/out/box/send/meeting/msg`, data);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:发布会议（每日会议，临时会议）
    async sendTemMeetingMst(id) {
      let res = await this.$http.post(
        `/tenant/out/box/send/meeting/msg/by/ism`,
        {
          id: id,
        }
      );
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 创建会议
    async createMeeting(type, obj) {
      if (type) {
        //TODO:带审核人
        let res = await this.$http.post(`/tenant/meeting/history/add`, obj);
        if (res.code == 200) {
          this.$message({ message: res.msg, type: "success" });
        } else {
          this.$message.error(res.msg);
        }
        return res;
      } else {
        //TODO:不带审核人
        let res = await this.$http.post(
          `/tenant/meeting/history/add/and/send`,
          obj
        );
        if (res.code == 200) {
          this.$message({ message: res.msg, type: "success" });
        } else {
          this.$message.error(res.msg);
        }
        return res;
      }
    },
    //TODO: 推送会议到审核员
    async sendMeeting(id) {
      let res = await this.$http.get(
        `/tenant/out/box/feign/send/meeting/assign`,
        {
          ismContentId: id,
        }
      );
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO：生成验证码
    async setMeetingCode(data) {
      let res = await this.$http.post(`/tenant/meeting/sign/code`, data);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO：会议签到
    async SigninCode(data) {
      let res = await this.$http.post(`/tenant/meeting/sign`, data);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO: 获取列表数字
    async getMeetingListNum() {
      let res = await this.$http.get(`/tenant/meeting/history/wait/num`);
      return res;
    },

    //TODO: 获取制度区域（指定表类型）
    async getreqAreaTypeList(type) {
      let res = await this.$http.get(`/tenant/area/list/by/dateType`, {
        dateType: type,
      });
      return res;
    },

    //TODO: 获取制度启动计划（指定表类型）
    async getreqStartPlanTypeList(type) {
      let res = await this.$http.get(`/tenant/ism/check/plan/list`, {
        dateType: type,
      });
      return res;
    },
      //TODO: 修改制度启动计划（指定表类型）
      async upStartPlanTypeList(obj) {
        let res = await this.$http.put(`/tenant/ism/check/plan`,obj);
        return res;
      },

      //TODO: 获取安全检查-日检 汇总人员配置
      async getCollectData(type){
        let res = await this.$http.get(`/tenant/ism/collect/${type}`);
        return res.data;
      },
      
      //TODO: 获取风险汇总 定时任务配置
      async getCollectCornData(jobId){
        let res = await this.$http.get(`/tenant/job/selectById/${jobId}`);
        return res;
      },
      //TODO: 风险汇总 汇总人员配置
      async upCollect(obj){
        let res = await this.$http.put(`/tenant/ism/collect`,obj);
        if (res.code == 200) {
          this.$message({ message: res.msg, type: "success" });
        } else {
          this.$message.error(res.msg);
        }
        return res;
      },
    //TODO：修改排序
    async sort(data) {
      let res = await this.$http.post(`/tenant/ism/sort`, data);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else if(res.code == 1){
        this.$message.warning(res.msg);
      }else {
        this.$message.error(res.msg);
      }
      return res;
    },

  },
};
